// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"509":"f9b3c01e","976":"41336eaa"}[chunkId] + ".chunk.css";
};